import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Customer, Address, OrderDTO, Order, DocumentsToPrint, AvailableShipmentTypeDTO } from "../../models";
import { Query } from "../../services";
import { UnsafeAction } from "../../actions/UnsafeAction"

/* tslint:disable */
@Injectable()
export class CheckoutActions {

	static SET_CUSTOMERS = "[CHECKOUT] set Customers"
	public setCustomer(customer:Customer): UnsafeAction {
		return {
			type: CheckoutActions.SET_CUSTOMERS,
			payload: customer
		}
	}

	static REMOVE_CUSTOMER = "[CHECKOUT] remove Customer"
	public removeCustomer(): UnsafeAction {
		return {
			type: CheckoutActions.REMOVE_CUSTOMER,
			payload: null
		}
	}

	static SET_BILLING_ADDRESS = "[CHECKOUT] set BillingAddress"
	public setBillingAddress(address: Address): UnsafeAction {
		return {
			type: CheckoutActions.SET_BILLING_ADDRESS,
			payload: address
		}
	}

	static SET_SHIPPING_ADDRESS = "[CHECKOUT] set ShippingAddress"
	public setShippingAddress(address: Address): UnsafeAction {
		return {
			type: CheckoutActions.SET_SHIPPING_ADDRESS,
			payload: address
		}
	}

	static SET_PAYMENT_TYPE = "[CHECKOUT] set PaymentType"
	public setPaymentType(paymentType: string): UnsafeAction {
		return {
			type: CheckoutActions.SET_PAYMENT_TYPE,
			payload: paymentType
		}
	}

	static SET_SHIPMENT_TYPE = "[CHECKOUT] set ShipmentType"
	public setShipmentType(shipmentType: string): UnsafeAction {
		return {
			type: CheckoutActions.SET_SHIPMENT_TYPE,
			payload: shipmentType
		}
	}

	static PLACE_ORDER = "[CHECKOUT] place order"
	public placeOrder(order: OrderDTO): UnsafeAction{
		return {
			type: CheckoutActions.PLACE_ORDER,
			payload: order
		}
	}

	static ORDER_PLACED = "[CHECKOUT] order placed"
	public orderPlaced(order: Order): UnsafeAction {
		return {
			type: CheckoutActions.ORDER_PLACED,
			payload: order
		}
	}

	static LOAD_TICKETS = "[CHECKOUT] load tickets"
	public loadTickets(secureOrderId: string): UnsafeAction {
		return {
			type: CheckoutActions.LOAD_TICKETS,
			payload: secureOrderId
		}
	}
	static PRINT_TICKETS = "[CHECKOUT] print tickets"
	public printTickets(status: any): UnsafeAction {
		return {
			type: CheckoutActions.PRINT_TICKETS,
			payload: status
		}
	}
	static COMPLETE_PAYMENT = "[CHECKOUT] compelte payment"
	public completePayment(orderUUID: string): UnsafeAction{
		return {
			type: CheckoutActions.COMPLETE_PAYMENT,
			payload: orderUUID
		}
	}

	static DELAY_PAYMENT = "[CHECKOUT] delay payment"
	public delayPayment(): UnsafeAction{
		return {
			type: CheckoutActions.DELAY_PAYMENT,
			payload: null
		}
	}

	static ORDER_PAID = "[CHECKOUT] order  paid"
	public orderPaid(order: Order): UnsafeAction {
		return {
			type: CheckoutActions.ORDER_PAID,
			payload: order
		}
	}

	static SET_DOCUMENTS_TO_PRINT = "[CHECKOUT] set documentsToPrint"
	public setDocumentsToPrint(documentsToPrint: DocumentsToPrint): UnsafeAction {
		return {
			type: CheckoutActions.SET_DOCUMENTS_TO_PRINT,
			payload: documentsToPrint
		}
	}

	static SET_TICKET_PRINTER = "[CHECKOUT] set Ticketprinter"
	public setTicketPrinter(printerId: string): UnsafeAction {
		return {
			type: CheckoutActions.SET_TICKET_PRINTER,
			payload: printerId
		}
	}

	static DISPLAY_DOCUMENTS = "[CHECKOUT] display Documents";
	public displayDocuments(orderUUID: string): UnsafeAction {
		return {
			type: CheckoutActions.DISPLAY_DOCUMENTS,
			payload: orderUUID
		}
	}

	static LOAD_AVAILABLE_SHIPMENTTYPES = "[CHECKOUT] Load AvailableShipmentTypes"
	public loadAvailableShipmentTypes(secureId: String): UnsafeAction {
		return {
			type: CheckoutActions.LOAD_AVAILABLE_SHIPMENTTYPES,
			payload: secureId
		}
	}

	static LOAD_AVAILABLE_SHIPMENTTYPES_SUCCESS = "[CHECKOUT] Load AvailableShipmentTypes success"
	public loadAvailableShipmentTypesSuccess(availableShipmentTypeDTO: AvailableShipmentTypeDTO): UnsafeAction {
		return {
			type: CheckoutActions.LOAD_AVAILABLE_SHIPMENTTYPES_SUCCESS,
			payload: availableShipmentTypeDTO
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/checkout.actions.ts